// extracted by mini-css-extract-plugin
module.exports = {"tooltipLink":"TripCartMessage_tooltipLink__H8Aw9"};